import React, { useContext } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import Login from "./components/Login";
// import Signup from './components/Signup';
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import UserDashboard from "./components/UserDashboard";
import UserManagement from "./pages/UserManagement";
import Department from "./pages/Department";
import Workers from "./pages/Workers";
import WIPLogin from "./WIP/Login"; // Importing the new Login component
import WIPDashboard from "./WIP/WIPHome";
import Stock from "./WIP/Stock";
import StockDetails from "./WIP/StockDetails";
import RMShortage from "./WIP/RMshortage";
import BoxRMShortage from "./WIP/BoxRMshortage";
import LotCompletionVerification from "./pages/LotCompletionVerification";
import TicketHome from "./Tickets/Home";
import AdminTicketManagement from "./pages/Ticketing";
import { PollingProvider } from "./PollingContext";
import Remarks from "./pages/Remarks";
import AddInventory from "./pages/AddInventory";
import ViewInventory from "./pages/ViewInventory";
import OrderDispatch from "./pages/OrderDispatch";
import LoopiChecking from "./pages/LoopiChecking";
import LoopiCheckingView from "./pages/LoopiCheckingView";
import SalesFlow from "./pages/SalesFlow";
import SalesFlowNotify from "./pages/SalesFlowNotify";
import SalesFlowScan from "./pages/SalesFlowScan";
import ExcelImport from "./pages/Excel_Import";
import RMUpload from "./pages/RM_Upload";
import RMView from "./pages/RM-View";
import RMDetailedView from "./pages/RM-Detailed-View";
import SalesFlowDispatch from "./pages/SalesFlowDispatch";
import StaffDashboard from "./pages/Staff_KPI";
import SalesFlowDispatchConfirm from "./pages/SalesFlowDispatch_Confirm";
import UserTickets from "./Tickets/UsersTicketRaise";
import WorkerTicketsView from "./Tickets/ViewWorkerTickets";
import UserTicketsView from "./Tickets/ViewUsersTickets";
import AdminTicketView from "./Tickets/AdminTicketView";
import SuperAdminTicketView from "./Tickets/SuperAdminTicketView";
import WorkerSupportEscalationView from "./Tickets/WorkerSupportEscalationView";
import StockValuationRemarks from "./pages/StockValuation";
import RMReturnCapture from "./pages/RM_Return";
import ADDRMReturn from "./pages/AddRMreturn";
import RMReturnVerification from "./pages/RMreturn_Verify";
import PurchaseBillUpload from "./pages/UploadPurchaseBill";
import ViewPurchaseBill from "./pages/ViewPurchaseBill";
import ManualRMIssueForm from "./pages/ManualRMIssueForm"; // adjust path as needed
import RMIssueLogs from "./pages/RMIssueLogs"; // ✅ update path if different
import EveryDayFoamCutting from "./pages/EveryDayFoamCutting";
import RemarksApproval from "./pages/Remarks_Approval";
import RedProcessLot from "./pages/RedProcessLot";
import RemarksSupervisor from "./pages/Remarks_Supervisor";

import CheckPoints from "./pages/CheckPoints";
import ViewCheckPoints from "./pages/ViewCheckPoints";

import ApprovalFormsPage from './pages/ApprovalFormsPage';
import BOMVerification from "./pages/BOM_Verification";
import StockReco from "./pages/StockReco";
import StockRecoReq from "./pages/StockRecoReq";
import LotDetails from "./pages/StockRecoLotDetails";
import Eexpenses from "./pages/ExpensesApprovel";
import LotIdStatus from "./pages/LotId_Status";
import LotIdStatusupdate from "./pages/LotId_StatusUpdate";
import SalesFlowExcel from "./pages/SalesFlowExcel";
import SalesFlowTally from "./pages/SalesFlowTallyDept";
import BOMdata from "./pages/BOM_DataView";
import RRCheckPoints from "./pages/RR_CheckPoints";
import SalesFlowSupervisor from "./pages/SalesFlowSupervisor";
import SheetQuentyLeather from "./pages/SheetQuentyLeather";
import SheetQuentyLeatherExcel from "./pages/SheetQuentyLeatherExcel";
import SalaryFinalization from "./pages/SalaryFinalization";
import LeatherAutomation from "./pages/LeatherAutomation";
import BoxPartyWise from "./pages/BoxPartyWise";
import DiePurchaseModule from "./pages/DiePurchaseModule";
import DeviceApproval from "./pages/DeviceApproval";
import AuditLogs from "./pages/AuditLogs";
import { Toaster } from "react-hot-toast";
import SharepointUpload from "./pages/SharepointUpload";
import ExpenseForm from "./pages/ExpenseForm";
import WorkerAdvanceForm from "./pages/WorkerAdvanceForm";
import PaidToForm from "./pages/PaidToForm";
import DebitNoteForm from "./pages/DebitNoteForm";
import WorkerAdvanceManagement from "./pages/WorkerAdvanceManagement";
import PurchaseInvoice from "./pages/PurchaseInvoice";
import PurchaseVoucherInvoice from "./pages/PurchaseVoucherInvoice";
import WipPhotoLogs from "./pages/WipPhotoLogs";
import HandoverScanner from './pages/wip/HandoverScanner';
import BarcodeScanner from './pages/BarcodeScanner';
import QCCheckScanner from './pages/wip/QCCheckScanner';
import KPIPenaltyDashboard from './pages/wip/KPIPenaltyDashboard';
import WorkerTaskApp from './pages/wip/WorkerTaskApp';
import ManagerRemediation from "./pages/wip/ManagerRemediation";
import ProductionReport from "./pages/wip/ProductionReport";
import PenaltyReview from "./pages/wip/PenaltyReview";
import AttendanceReport from "./pages/AttendanceReport";
import WorkerRatingHistory from "./pages/WorkerRatingHistory";
import WipTicketsDashboard from "./pages/wip/WipTicketsDashboard";
import TicketInbox from "./pages/wip/TicketInbox";
import LoopPunctureReadiness from "./pages/wip/LoopPunctureReadiness";
// import WIPProtectedRoute from './WIP/WIP-AuthChecker';
import AiChatWidget from "./components/AiChatWidget";
import { AuthContext } from "./AuthContext";
import WorkerSalaryAdmin from "./pages/WorkerSalaryAdmin";
import WorkerSalaryView from "./pages/WorkerSalaryView";
import SupervisorDepartments from "./pages/SupervisorDepartments";
import WorkersMaster from "./pages/WorkersMaster";
import CuttingLotDetails from "./pages/wip/CuttingLotDetails";
import SupervisorCuttingLotDetails from "./pages/wip/SupervisorCuttingLotDetails";
import FoamBarcodeGenerator from "./pages/wip/FoamBarcodeGenerator";

function App() {
  const { user } = useContext(AuthContext);
  const isAiChatEnabled = String(process.env.REACT_APP_AI_CHAT_ENABLED).toLowerCase() === "true";
  const canUseAiChat = isAiChatEnabled && user && ["1021", "10"].includes(String(user.EmployeeID));
  const normalizedRole = String(user?.Auth || "").trim().toLowerCase();
  const normalizedDepartment = String(user?.Department || "").trim().toLowerCase();
  const isAccountsDashboardUser = normalizedRole === "accounts" ||
    normalizedDepartment.includes("account");

  return (
    <PollingProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              borderRadius: "10px",
              color: "#fff",
            },
            success: {
              style: {
                background: "#16a34a", // green
              },
              iconTheme: {
                primary: "#fff",
                secondary: "#16a34a",
              },
            },
            error: {
              style: {
                background: "#dc2626", // red
              },
              iconTheme: {
                primary: "#fff",
                secondary: "#dc2626",
              },
            },
          }}
        />
        <div className="">
          <Routes>
            {/* Define all your routes */}
            <Route path="/" element={<Login />} />
            
            <Route
              path="/wip-tickets" 
              element={
                <ProtectedRoute>
                  <WipTicketsDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ticket-inbox"
              element={
                <ProtectedRoute>
                  <TicketInbox />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wip-loop-puncture-readiness"
              element={
                <ProtectedRoute>
                  <LoopPunctureReadiness />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wip-kpi-penalties"
              element={
                <ProtectedRoute roles={["Admin", "SuperAdmin"]}>
                  <KPIPenaltyDashboard />
                </ProtectedRoute>
              } 
            />
            
            <Route
              path="/wip-barcode-scanner"
              element={
                <ProtectedRoute>
                  <BarcodeScanner />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/wip-handover-scanner"
              element={<HandoverScanner />} 
            />
            <Route
              path="/wip-qc-scanner"
              element={
                <ProtectedRoute roles={["Admin", "Admin_wip", "QC"]}>
                  <QCCheckScanner />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/wip-final-check"
              element={
                <ProtectedRoute roles={["Admin", "Admin_wip", "QC", "Final Checker"]}>
                  <QCCheckScanner mode="FINAL" />
                </ProtectedRoute>
              }
            />

            <Route
              path="/wip-worker-app"
              element={<WorkerTaskApp />} 
            />

            <Route
              path="/cutting-lot-details"
              element={
                <ProtectedRoute>
                  <CuttingLotDetails />
                </ProtectedRoute>
              }
            />

            <Route
              path="/manager-remediation"
              element={<ManagerRemediation />} 
            />

            <Route
              path="/production-report"
              element={<ProductionReport />} 
            />

            <Route
              path="/hr-penalty-review"
              element={<PenaltyReview />} 
            />

            {/* <Route path="/signup" element={<Signup />} /> */}
            <Route
              path="/Main-dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
             <Route
              path="/attendance"
              element={
                <ProtectedRoute allowedRoles={["admin", "superadmin", "owner", "supervisor"]}>
                  <AttendanceReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/worker-rating-history"
              element={
                <ProtectedRoute allowedRoles={["admin", "superadmin", "owner", "accounts"]} allowedDepartments={["accounts department"]}>
                  <WorkerRatingHistory />
                </ProtectedRoute>
              }
            />
            {/* Catch-all route to redirect unknown paths to Login/Dashboard */}
            <Route
              path="/User-dashboard"
              element={
                <ProtectedRoute>
                  {isAccountsDashboardUser
                    ? <Navigate to="/Main-dashboard" replace />
                    : <UserDashboard />}
                </ProtectedRoute>
              }
            />
           <Route
              path="/approval-forms"
              element={
                <ProtectedRoute>
                  <ApprovalFormsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/department"
              element={
                <ProtectedRoute>
                  <Department />
                </ProtectedRoute>
              }
            />
            <Route
              path="/supervisor-departments"
              element={
                <ProtectedRoute allowedRoles={["admin", "superadmin", "owner", "accounts"]} allowedDepartments={["accounts department"]}>
                  <SupervisorDepartments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/supervisor-cutting-lot-details"
              element={
                <ProtectedRoute allowedRoles={["admin", "superadmin", "owner", "supervisor"]}>
                  <SupervisorCuttingLotDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/workers"
              element={
                <ProtectedRoute>
                  <Workers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/workers-master"
              element={
                <ProtectedRoute allowedRoles={["superadmin", "admin", "supervisor", "staff", "accounts"]} allowedDepartments={["accounts department"]}>
                  <WorkersMaster />
                </ProtectedRoute>
              }
            />
            {/* New Routes for WIP */}
            <Route path="/wip-login" element={<WIPLogin />} />
            <Route path="/wip-dashboard" element={<WIPDashboard />} />
            <Route path="/wip-photo-logs" element={<WipPhotoLogs />} />
            <Route path="/Stock" element={<Stock />} />
            {/* <Route path="/stock-details" element={<StockDetails/>}/> */}
            <Route path="/stock-details/:fileName" element={<StockDetails />} />
            <Route path="/rm-shortage" element={<RMShortage />} />
            <Route path="/box-rm-shortage" element={<BoxRMShortage />} />
            <Route path="/lot-completion" element={<LotCompletionVerification />} />

            {/* New Routes for WIP */}
            <Route
              path="/ticket-home"
              element={
                <ProtectedRoute>
                  <TicketHome />
                </ProtectedRoute>
              }
            />

            <Route
              path="/ticket-admin"
              element={
                <ProtectedRoute>
                  <AdminTicketManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/remarks"
              element={
                <ProtectedRoute>
                  <Remarks />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-inventory"
              element={
                <ProtectedRoute>
                  <AddInventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-inventory"
              element={
                <ProtectedRoute>
                  <ViewInventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order-dispatch"
              element={
                <ProtectedRoute>
                  <OrderDispatch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/loopi-checking"
              element={
                <ProtectedRoute>
                  <LoopiChecking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/loopi-CheckingView"
              element={
                <ProtectedRoute>
                  <LoopiCheckingView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-flow"
              element={
                <ProtectedRoute>
                  <SalesFlow />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-flowNotify"
              element={
                <ProtectedRoute>
                  <SalesFlowNotify />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-scan"
              element={
                <ProtectedRoute>
                  <SalesFlowScan />
                </ProtectedRoute>
              }
            />
            <Route
              path="excel-import"
              element={
                <ProtectedRoute>
                  <ExcelImport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/RM-Upload"
              element={
                <ProtectedRoute>
                  <RMUpload />
                </ProtectedRoute>
              }
            />
            <Route
              path="/RM-View"
              element={
                <ProtectedRoute>
                  <RMView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/RM-detailed-view/:fileName"
              element={
                <ProtectedRoute>
                  <RMDetailedView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-flow-dispatch"
              element={
                <ProtectedRoute>
                  <SalesFlowDispatch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Dispatch-Confirm"
              element={
                <ProtectedRoute>
                  <SalesFlowDispatchConfirm />
                </ProtectedRoute>
              }
            />
            {/* Create new Route On 8 March 25 for staff */}
            <Route
              path="/staff-dashboard"
              element={
                <ProtectedRoute>
                  <StaffDashboard />
                </ProtectedRoute>
              }
            />
            {/* New Routes on 15 Apr 25 */}
            <Route
              path="/User-Tickets"
              element={
                <ProtectedRoute>
                  <UserTickets />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Users-Ticket-View"
              element={
                <ProtectedRoute>
                  <UserTicketsView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/workers-Ticket-View"
              element={
                <ProtectedRoute>
                  <WorkerTicketsView />
                </ProtectedRoute>
              }
            />
            {/* New Routes on 16 Apr 25 */}
            <Route
              path="/Admin-Ticket-View"
              element={
                <ProtectedRoute>
                  <AdminTicketView />
                </ProtectedRoute>
              }
            />

            <Route
              path="/SuperAdmin-Ticket-View"
              element={
                <ProtectedRoute>
                  <SuperAdminTicketView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/worker-support-escalations"
              element={
                <ProtectedRoute>
                  <WorkerSupportEscalationView />
                </ProtectedRoute>
              }
            />
            {/* new Route created on 18 Apr 25 */}
            <Route
              path="/Stock-Valuation"
              element={
                <ProtectedRoute>
                  <StockValuationRemarks />
                </ProtectedRoute>
              }
            />
            {/* new Route created on 18 Apr 25 */}
            <Route
              path="/RM-Return"
              element={
                <ProtectedRoute>
                  <RMReturnCapture />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Add-Return-RM"
              element={
                <ProtectedRoute>
                  <ADDRMReturn />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Verify-Return-RM"
              element={
                <ProtectedRoute>
                  <RMReturnVerification />
                </ProtectedRoute>
              }
            />
            {/*Purchase Bill Upload */}
            <Route
              path="/Bill-Upload"
              element={
                <ProtectedRoute>
                  <PurchaseBillUpload />
                </ProtectedRoute>
              }
            />
            <Route
              path="/View-Bill"
              element={
                <ProtectedRoute>
                  <ViewPurchaseBill />
                </ProtectedRoute>
              }
            />
            {/* other routes */}
            <Route
              path="/manual-rm-issue"
              element={
                <ProtectedRoute>
                  <ManualRMIssueForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rm-issued-logs"
              element={
                <ProtectedRoute>
                  <RMIssueLogs />
                </ProtectedRoute>
              }
            />
               {/* 30 May 25 */}
          <Route
          path="/EveryDay-FoamCutting" // Not IN Use Currently
          element={
            <ProtectedRoute>
              <EveryDayFoamCutting/>
            </ProtectedRoute>
          }
          />
             <Route
          path="/Approval"
          element={
            <ProtectedRoute>
              <RemarksApproval/>
            </ProtectedRoute>
          }
          />
          <Route
          path="/Red-Process"
          element={
            <ProtectedRoute>
              <RedProcessLot/>
            </ProtectedRoute>
          }
          />
          <Route
          path="/Remark-Supervisor"
          element={
            <ProtectedRoute>
              <RemarksSupervisor/>
            </ProtectedRoute>
          }
          />
          <Route
          path="/Check-Points"
          element={
            <ProtectedRoute>
              <CheckPoints/>
            </ProtectedRoute>
          }
          />
            <Route
          path="/View-Check-Points"
          element={
            <ProtectedRoute>
              <ViewCheckPoints/>
            </ProtectedRoute>
          }
          />
          <Route
          path="/BOM-Verification"
          element={
            <ProtectedRoute>
              <BOMVerification/>
            </ProtectedRoute>
          }
          />
          {/* New Routes Created on 25 Jun 25 */}
        <Route
          path="/Stock-Reco"
          element={
            <ProtectedRoute>
              <StockReco/>
            </ProtectedRoute>
          }
          />
           <Route
          path="/Stock-Reco-Req"
          element={
            <ProtectedRoute>
              <StockRecoReq/>
            </ProtectedRoute>
          }
          />
           <Route
          path="/lot/:lotId"
          element={
            <ProtectedRoute>
              <LotDetails/>
            </ProtectedRoute>
          }
          />
          {/* New Routes Created on 2 Jul 25 */}
          <Route
          path="/approved-expenses"
          element={
            <ProtectedRoute>
              <Eexpenses/>
            </ProtectedRoute>
          }
          />
            {/* New Routes Created on 14 Jul 25 */}
          <Route
          path="/lot-status"
          element={
            <ProtectedRoute>
              <LotIdStatus/>
            </ProtectedRoute>
          }
          />
          <Route
          path="/update-lot-status"
          element={
            <ProtectedRoute>
              <LotIdStatusupdate/>
            </ProtectedRoute>
          }
          />
           <Route
          path="/Sales-Flow-Excelimport"
          element={
            <ProtectedRoute>
              <SalesFlowExcel/>
            </ProtectedRoute>
          }
          />
          <Route
          path="/Sales-Flow-Tally"
          element={
            <ProtectedRoute>
              <SalesFlowTally/>
            </ProtectedRoute>
          }
          />
            <Route
          path="/Bom-DataView"
          element={
            <ProtectedRoute>
              <BOMdata/>
            </ProtectedRoute>
          } />

          <Route
          path="/RR_CheckPoints"
          element={
            <ProtectedRoute>
              <RRCheckPoints/>
            </ProtectedRoute>
          }
          />
          {/* New Route Created on 9-Sep-25 */}
          <Route 
          path="/sales-form"
          element={
            <ProtectedRoute>
              <SalesFlowSupervisor />
            </ProtectedRoute>
          }/>

          <Route
            path="/sheet-quantity-leather"
            element={
              <ProtectedRoute>
                <SheetQuentyLeather />
              </ProtectedRoute>
            }
          />

          <Route
            path="/sheet-quantity-leather-excel"
            element={
              <ProtectedRoute>
                <SheetQuentyLeatherExcel />
              </ProtectedRoute>
            }
          />

          <Route
            path="/salary-finalization"
            element={
              <ProtectedRoute>
                <SalaryFinalization />
              </ProtectedRoute>
            }
          />

          <Route
            path="/leather-automation"
            element={
              <ProtectedRoute>
                <LeatherAutomation />
              </ProtectedRoute>
            }
          />

          <Route
            path="/box-party-wise"
            element={
              <ProtectedRoute allowedRoles={["admin", "superadmin", "supervisor"]}>
                <BoxPartyWise />
              </ProtectedRoute>
            }
          />

          <Route
            path="/die-purchase-summary"
            element={
              <ProtectedRoute>
                <DiePurchaseModule />
              </ProtectedRoute>
            }
          />

          <Route
            path="/audit-logs"
            element={
              <ProtectedRoute>
                <AuditLogs />
              </ProtectedRoute>
            }
          />

          {/* <Route
            path="/sharepoint-upload"
            element={
              <ProtectedRoute>
                <SharepointUpload />
              </ProtectedRoute>
            }
          /> */}

          <Route
            path="/expense-form-upload"
            element={
              <ProtectedRoute>
                <ExpenseForm />
              </ProtectedRoute>
            }
          />

          <Route
            path="/worker-advance-form"
            element={
              <ProtectedRoute>
                <WorkerAdvanceForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/paid-to"
            element={
              <ProtectedRoute>
                <PaidToForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/debit-note"
            element={
              <ProtectedRoute>
                <DebitNoteForm />
              </ProtectedRoute>
            }
          />
          <Route path="/worker-advance-management" element={<ProtectedRoute allowedRoles={["admin", "superadmin", "owner", "supervisor", "Supervisor", "accounts", "Accounts"]}><WorkerAdvanceManagement /></ProtectedRoute>} />

          <Route
            path="/device-management"
            element={
              <ProtectedRoute>
                <DeviceApproval />
              </ProtectedRoute>
            }
          />

          <Route
            path="/purchase-dashboard"
            element={
              <ProtectedRoute>
                <PurchaseInvoice />
              </ProtectedRoute>
            }
          />

          <Route
            path="/purchase-dashboard/voucher"
            element={
              <ProtectedRoute
                allowedRoles={["admin", "superadmin", "owner", "accounts"]}
                allowedDepartments={["accounts", "accounts department"]}
              >
                <PurchaseVoucherInvoice />
              </ProtectedRoute>
            }
          />

          {/* Add any additional routes here */}

          <Route
            path="/worker-salary-admin"
            element={
              <ProtectedRoute allowedRoles={["admin", "superadmin", "owner", "supervisor", "accounts"]} allowedDepartments={["accounts department"]}>
                <WorkerSalaryAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/worker-salary-view"
            element={
              <ProtectedRoute>
                <WorkerSalaryView />
              </ProtectedRoute>
            }
          />

          <Route
            path="/wip-photo-logs"
            element={
              <ProtectedRoute>
                <WipPhotoLogs />
              </ProtectedRoute>
            }
          />

          <Route
            path="/foam-cutting-barcodes"
            element={
              <ProtectedRoute allowedRoles={["admin", "superadmin", "owner", "supervisor"]}>
                <FoamBarcodeGenerator />
              </ProtectedRoute>
            }
          />

          </Routes>
          {canUseAiChat && <AiChatWidget />}
        </div>
      </BrowserRouter>
    </PollingProvider>
  );
}

export default App;
